var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shouldTrack && this.conversion)?_c('div',[_c('img',{attrs:{"height":"1","width":"1","border":"0","src":"//conv.indeed.com/pagead/conv/1703618974414234/?script=0"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }